import { DateTime } from 'luxon';
import React, { useCallback, useRef } from 'react';
import { useAppSelector } from 'src/app/redux/createAction';
import { Widget } from 'src/entities/widgets/Widget';
import { WidgetWithRatings } from 'src/entities/widgets/WidgetWithRatings';
import { ButtonPrimary } from 'src/shared/ui/_buttons/ButtonPrimary';
import s from './RatingWidgetDownload.module.scss';

function downloadBlob(blob: Blob, filename: string) {
	const objectUrl = URL.createObjectURL(blob);

	const link = document.createElement('a');
	link.href = objectUrl;
	link.download = filename;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);

	setTimeout(() => URL.revokeObjectURL(objectUrl), 5000);
}

export const RatingWidgetDownload: React.FC = () => {
	const companiesLookupResult = useAppSelector((state) => state.userInfo.companiesLookupResult);

	const widgetWithRatingRef: any = useRef();
	const widgetRef: any = useRef();

	const downloadSVG = useCallback((ref: React.MutableRefObject<any>) => {
		const svg = ref.current.innerHTML;
		const blob = new Blob([svg], { type: 'image/svg+xml' });
		downloadBlob(blob, 'smallCertificate.svg');
	}, []);

	// * Render
	if (!(companiesLookupResult !== null && Array.isArray(companiesLookupResult) && companiesLookupResult.length > 0)) {
		return null;
	}

	const { dateOfIssue, properties } = companiesLookupResult[0];

	if (dateOfIssue === null || properties === null) {
		return null;
	}

	const { overallDiversityAbsoluteRating, overallDiversityRelativeRating } = properties;

	const yearOfIssue = DateTime.fromISO(dateOfIssue).year;

	return (
		<div className={s.container}>
			<div className={s.widget}>
				<div ref={widgetWithRatingRef}>
					<WidgetWithRatings
						absoluteRating={overallDiversityAbsoluteRating}
						relativeRating={overallDiversityRelativeRating}
						yearOfIssue={yearOfIssue}
					/>
				</div>

				<ButtonPrimary onClick={() => downloadSVG(widgetWithRatingRef)}>Download SVG widget with ratings</ButtonPrimary>
			</div>

			<div className={s.widget}>
				<div ref={widgetRef}>
					<Widget yearOfIssue={yearOfIssue} />
				</div>

				<ButtonPrimary onClick={() => downloadSVG(widgetRef)}>Download SVG widget</ButtonPrimary>
			</div>
		</div>
	);
};
